module.exports = __webpack_public_path__ + "media/abk/assets/images/cookie-4697e134d41996024250a32c568f426a.png";